import React from "react";
import { Box } from "@mui/system";
import { Container, Typography } from "@mui/material";
import { mainHeading, subHeading } from "../styles/style";
import Layout from "../assets/Layout";

export default function RefundPolicy() {
  return (
    <>
      <Layout>
        <Box sx={{ textAlign: "center", my: 10 }}>
          <Typography sx={subHeading}>Refund Policy</Typography>
          <Typography sx={mainHeading}>Refund Policy</Typography>
        </Box>

        <Container>
          <Box>
            <Typography className="textDetails">
              The PPLACD team delivers all the services with proficiency and
              professionalism. Though if you wish to cancel the service, we are
              happy to provide you with a sufficient refund.
            </Typography>
            <Typography className="textDetails">
              Our refund amount will vary under the following conditions,
            </Typography>
            </Box>
           <Box>
            <Typography className="subHeading1Details">
            If the candidate cancels the course,
            </Typography>

            <ol>
              <li className="textDetails">
                48 hours prior to the beginning of the session, 85% will get
                refunded.
              </li>
              <li className="textDetails">
                24 hours prior to the beginning of the session, 75% will get
                refunded.
              </li>
              <li className="textDetails">
                Within less than 24 hours of the beginning of the session, 60%
                will get refunded.
              </li>
              <li className="textDetails">
                If the session/course is canceled in between the running
                session, then the candidate will get the refund as per the run
                time and reason for canceling the course/session. Please note
                the amount may vary from 0% to 50%.
              </li>
            </ol>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">
              If the coach/mentor cancels the session,
            </Typography>
            <ol>
              <li className="textDetails">
                The coach and mentor are not applicable for the refund.
              </li>
              <li className="textDetails">
                If they have taken a few sessions, then the payment will depend
                on the completion of those sessions. The admin has the right to
                decide the amount.
              </li>
              <li className="textDetails">
                The candidate will get the maximum refund. In case the coach and
                mentor cancel the course/session.
              </li>
            </ol>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">
            Termination of the subscription package
            </Typography>
            <Typography className="textDetails">
            Once any individual buys our subscription, we are bound to deliver them with 
full service as mentioned in their package. If we fail to do so, we are applicable 
to provide them sufficient refund as per the package and package usage.
            </Typography>
           
            <Typography className="textDetails">
              We will take swift action against anyone found in violation of the
              above terms. Suppose PPLACD is presented with evidence that its
              services have been used contrary to this or any other part of
              these Terms of Use. In that case, PPLACD may, in its sole
              discretion, remove the materials, terminate the accounts of the
              involved users, and take this matter under legal review.
            </Typography>
          </Box>
          <Box my={2}>
            <Typography className="subHeading1Details">
              Warranty and Limitation of Liability
            </Typography>
            <Typography className="textDetails">
              Some companies are posting the same job post to multiple
              mediums/channels. Therefore, we don't take the guarantee of
              providing unique job opportunities.
            </Typography>
           </Box>
        </Container>
      </Layout>
    </>
  );
}
